import { render, staticRenderFns } from "./Enfermeros.vue?vue&type=template&id=73749970&scoped=true"
import script from "./Enfermeros.vue?vue&type=script&lang=js"
export * from "./Enfermeros.vue?vue&type=script&lang=js"
import style0 from "./Enfermeros.vue?vue&type=style&index=0&id=73749970&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73749970",
  null
  
)

export default component.exports